import React, { useState } from 'react';
import {
    Typography,
    Accordion,
    Grid,
    AccordionSummary
} from '@material-ui/core';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import MaterialTable from "material-table";

export const LoanDetailView = ({ LoanTransactionDetails, IsDefaultExpand }) => {

    const [AccordianTitle, setAccordianTitle] = useState(
        IsDefaultExpand === true ?
            "Loan Deduction History" :
            "Please Expand to View Loan Deduction History"
    )
    const [HideUserFields, setHideUserFields] = useState(false)
    function toggleUserFields(expanded) {
        setHideUserFields(!HideUserFields);
        if (expanded === false) {
            setAccordianTitle("Please Expand to View Loan Deduction History")
        } else {
            setAccordianTitle("Loan Deduction History")
        }
    };

    const processLoanTransactionData = () => {
        if (!LoanTransactionDetails || LoanTransactionDetails.length === 0) return [];
        const groupedByDate = {};
        
        const formatMonthYear = (dateString) => {
            const date = new Date(dateString);
            const options = { month: 'long', year: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        };

        let totalOutstanding = LoanTransactionDetails[0].principalAmount;

        LoanTransactionDetails.forEach(transaction => {
            const date = transaction.effectiveDate.split('T')[0];
            const monthYear = formatMonthYear(transaction.effectiveDate);
            
            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    date: date,
                    monthYear: monthYear,
                    monthlyInterest: 0,
                    monthlyPrincipal: 0,
                    totalInstallment: 0,
                    outstanding: totalOutstanding
                };
            }
            
            if (transaction.transactionTypeCode === 'LNI') {
                groupedByDate[date].monthlyInterest = transaction.amount;
            } else if (transaction.transactionTypeCode === 'LNP') {
                groupedByDate[date].monthlyPrincipal = transaction.amount;
                groupedByDate[date].outstanding -= transaction.amount;
                totalOutstanding -= transaction.amount;
            }
            
            groupedByDate[date].totalInstallment = 
                groupedByDate[date].monthlyInterest + groupedByDate[date].monthlyPrincipal;
        });
        
        return Object.values(groupedByDate).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    return (
        <Accordion
            defaultExpanded={IsDefaultExpand}
            onChange={(e, expanded) => {
                toggleUserFields(expanded)
            }}
        >
            <AccordionSummary
                expandIcon={
                    <ArrowDropDownCircleIcon
                        color="primary"
                        fontSize="large"
                    />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <div>
                    <Typography
                        color="textPrimary"
                        variant="h5"
                    >{AccordianTitle}</Typography>
                </div>
            </AccordionSummary>

            {
                LoanTransactionDetails !== null && LoanTransactionDetails.length !== 0 ?
                    <Grid container spacing={3} >
                        <Grid item md={12} xs={12}>
                            <MaterialTable
                                title="Multiple Actions Preview"
                                columns={[
                        {
                            title: 'Month/Year', 
                            cellStyle: { paddingLeft:'100px' },
                            field: 'monthYear'
                        },
                        {
                            title: 'Monthly Installment', 
                            field: 'totalInstallment',
                            cellStyle: { textAlign: "right",paddingRight:'100px' },
                            render: rowData => rowData.totalInstallment?.toFixed(2) || '0.00'
                        },
                        { 
                            title: 'Monthly Interest', 
                            field: 'monthlyInterest',
                            cellStyle: { textAlign: "right" ,paddingRight:'100px'},
                            render: rowData => rowData.monthlyInterest?.toFixed(2) || '0.00'
                        },
                        { 
                            title: 'Monthly Principal', 
                            field: 'monthlyPrincipal',
                            cellStyle: { textAlign: "right",paddingRight:'100px' },
                            render: rowData => rowData.monthlyPrincipal?.toFixed(2) || '0.00'
                        },
                        { 
                            title: 'Outstanding Amount', 
                            field: 'outstanding',
                            cellStyle: { textAlign: "right",paddingRight:'100px' },
                            render: rowData => rowData.outstanding?.toFixed(2) || '0.00'
                        }
                    ]}
                                data={processLoanTransactionData()}
                                options={{
                                    exportButton: false,
                                    showTitle: false,
                                    headerStyle: { textAlign: "center", height: '1%' },
                                    cellStyle: { textAlign: "left" },
                                    columnResizable: false,
                                    actionsColumnIndex: -1,
                                    pageSize: 5,
                                    search: true
                                }}
                            />
                        </Grid>
                    </Grid> : < > <br /><Typography variant='h5'>No tranasaction details to show</Typography> </>
            }
        </Accordion>
    )
}